var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext, useMonitorNavigation } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH, getRiskRequest } from "./useRequest";
import { useRef, useState } from "@max/max";
import { convertLinkToAppMiddleOpenLink } from "@/utils/common";
import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from "@nibfe/mkt-env-api";
import { ORDER_URL_IN_MT, ORDER_URL_IN_WX } from "@/const";
export function useRecommendPoi(options) {
    const ctx = useMonitorEngineContext();
    const [recommendPoiData, setRecommendPoiData] = useState();
    const [poiList, setPoiList] = useState([]);
    const poiListRef = useRef([]);
    const { requestStatus, request } = useRequest(API_PATH.RECOMMEND_POI);
    const { monitorNavigateTo } = useMonitorNavigation();
    function loadRecommendPoi() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { uuid, lat, lng, cityInfo } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) || {};
                const transformLat = Number.isNaN(Number(lat)) || Number(lat) === 0 ? -1.0 : Number(lat);
                const transformLng = Number.isNaN(Number(lng)) || Number(lng) === 0 ? -1.0 : Number(lng);
                const { cityId, locCityId } = cityInfo || {};
                if (transformLat === -1.0 || transformLng === -1.0) {
                    const tryJsonStringify = (obj) => {
                        try {
                            return JSON.stringify(obj);
                        }
                        catch (error) {
                            return JSON.stringify({});
                        }
                    };
                    (_c = (_b = ctx._raptorReport).monitorReportLog) === null || _c === void 0 ? void 0 : _c.call(_b, '组队赢免单经纬度异常', {
                        lat,
                        lng
                    }, {
                        category: 'jsError',
                        level: 'info',
                        tags: {
                            commonParams: tryJsonStringify((_d = ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.commonParams)
                        }
                    });
                }
                // 获取风险参数
                const riskParams = yield getRiskRequest(uuid);
                const res = yield request({
                    flowSource: 7,
                    // 固定传7
                    // @ts-expect-error 
                    uuid: uuid || riskParams.uuid || '',
                    lat: transformLat,
                    lng: transformLng,
                    pageNo: 1,
                    // 默认填1
                    pageSize: 3,
                    // 建议3个以内
                    cityId: cityId !== null && cityId !== void 0 ? cityId : 1,
                    // 拿不到传1
                    locateCityId: locCityId !== null && locCityId !== void 0 ? locCityId : 1,
                    // 拿不到传1
                    // 客户端核心参数，从风险参数中获取
                    utm_campaign: riskParams.utmCampaign || '',
                    utm_content: riskParams.utmContent || '',
                    utm_medium: riskParams.utmMedium || 'android',
                    utm_source: riskParams.utmSource || '',
                    utm_term: riskParams.utmTerm || '',
                    version_name: riskParams.versionName || '12.42.200'
                });
                if (res && Array.isArray(res.remainRecPoiInfo)) {
                    setRecommendPoiData(res);
                    setPoiList(res.remainRecPoiInfo);
                    poiListRef.current = res.remainRecPoiInfo;
                    (_f = (_e = ctx._raptorReport).monitorReportBizSuccess) === null || _f === void 0 ? void 0 : _f.call(_e, {
                        apiPath: API_PATH.RECOMMEND_POI
                    });
                    return res;
                }
                else {
                    throw new Error('获取推荐POI数据失败');
                }
            }
            catch (error) {
                (_h = (_g = ctx._raptorReport).monitorReportBizFailed) === null || _h === void 0 ? void 0 : _h.call(_g, {
                    apiPath: API_PATH.RECOMMEND_POI
                });
                (_k = (_j = ctx._raptorReport).monitorReportLog) === null || _k === void 0 ? void 0 : _k.call(_j, error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                // throw error;
            }
        });
    }
    const browseRecommendedHotelPoi = () => {
        var _a, _b, _c;
        const poiId = ((_b = (_a = poiListRef.current) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.poiId) || ((_c = poiList === null || poiList === void 0 ? void 0 : poiList[0]) === null || _c === void 0 ? void 0 : _c.poiId);
        // block 717819091
        // 临时patch，解决后端兜底的问题
        if (poiId === null || poiId === undefined || Number.isNaN(Number(poiId)) || !poiId || Number(poiId) === 717819091) {
            if (isMeituanAppOrWebview()) {
                monitorNavigateTo({
                    url: ORDER_URL_IN_MT
                });
            }
            else {
                monitorNavigateTo({
                    url: ORDER_URL_IN_WX
                });
            }
            return;
        }
        const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}`);
        if (isMeituanAppOrWebview()) {
            return monitorNavigateTo({
                url: `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}`
            });
        }
        else if (isDianpingAppOrWebview()) {
            // 点评app
            return monitorNavigateTo({
                url: `dianping://shopinfo?shopuuid=${poiId}`
            });
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    // 美团小程序
                    return monitorNavigateTo({
                        url: `/hotel/pages/poi/pages/index/index?poiId=${poiId}`,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                case PlatformType.mtHotelMinaWebview:
                    // 美团酒店小程序
                    return monitorNavigateTo({
                        url: `/pages/poi/pages/index/index?poiId=${poiId}`,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                case PlatformType.dpMinaWebview:
                    // 点评小程序
                    const url = `/packages/hotel/pages/poi/pages/index/index?shopId=${poiId}&shopUuid=${poiId}`;
                    return monitorNavigateTo({
                        url,
                        _web: {
                            miniProgramNative: true
                        }
                    });
                default:
                    if (options.wxLaunchPoiDetailUrlSchema) {
                        const encodedParams = encodeURIComponent(`poiId=${poiId}`);
                        const targetUrl = `${options.wxLaunchPoiDetailUrlSchema}&cq=${encodedParams}`;
                        return monitorNavigateTo({
                            url: targetUrl
                        });
                    }
                    else {
                        return monitorNavigateTo({
                            url: envokePoiDetailLink
                        });
                    }
            }
        }
        else {
            return monitorNavigateTo({
                url: envokePoiDetailLink
            });
        }
    };
    return {
        loadRecommendPoi,
        requestStatus,
        recommendPoiData,
        poiList,
        browseRecommendedHotelPoi
    };
}
